<template>
  <div id="app">
    
    <Message></Message>
    <router-view></router-view>
    <Loading :isOpen="store.state.isLoading"></Loading>
    <FlashMsg v-model:isOpen="store.state.isShowFlashMsg" :text="store.state.flashMsgText"></FlashMsg>
  </div>
</template>
<style lang="scss" scoped src="@/assets/scss/page/app.scss"></style>
<script>
import Message from '@/view/message/index.vue';
import Loading from '@/components/ui/loading/index.vue';
import FlashMsg from '@/components/ui/flashMsg/index.vue';
import { onMounted, onBeforeMount } from '@vue/runtime-core';
import { apiInitSetting, apiWsSite } from '@/api/api';
import { useStore } from 'vuex';
// import { useRouter } from 'vue-router'
import router from '@/router/index.ts';
import { POPUP ,FEATURENAME, THEME_OPT, BRAND} from '@/enum/enum';
// import {setCookie} from '@/utils/cookies';
import {useI18n} from 'vue-i18n';
import { isMobileDevice } from '@/utils/utils';
import {getBrand} from '@/utils/theme';

export default {
  components: {
    Message,
    FlashMsg,
    Loading,
  },
  setup(){
    const _env = process.env.NODE_ENV;
    const store = useStore();
    const route = router;
    
    store.commit('setEnv', _env);

    const { t } = useI18n();
    
    onBeforeMount(()=>{
      isMobileDevice()
    })
    
    onMounted(async() => {
      apiInitSetting(); 
      window.addEventListener('offline', function () {
        console.log('網路斷線！');
        const flashMsg = {
                data: t('__flash.__internetDisconnectionPleaseTryAgain'),
                isShow: true
            }
            store.commit('setFlashMsg', flashMsg);
      });
      window.addEventListener('online', function () {
        console.log('網路連線！');
      });

      changeTheme();
    })

    const queryApiWsSite = async () => {
      try {
        await apiWsSite();
      }
      catch (error) {
        console.log('ws error',error)
        return error;
      }
    }

    console.log('route',route)
    route.beforeEach((to, from, next) => {
      if(from.name == FEATURENAME.CALIBRATION){
        if(to.name != FEATURENAME.ADVANCED){
          store.commit('nextToAdvance', false);
        }
      }

      if(to.name == FEATURENAME.MODIFY){
        store.commit('setRouterPath', from.name)
      }
      let isAdvanced = FEATURENAME.ADVANCED == from.name ? true : false;
      if(FEATURENAME.ADVANCED == from.name ){
        if(to.name == FEATURENAME.DASHBOARD  ){
          next()
        }
        else if(to.name ==  FEATURENAME.CALIBRATION){
          store.commit('nextToAdvance', true);
          store.commit('backToCalibration', true);
          next()
        }else{
          console.log('aaaaaa', to.name)
          const modalConfig = {
          type: POPUP.LEAVEADVANCED,
          data: {
            goNext : next,
            isAdvanced,
          },
          isShow: true,
          }
          store.commit('setIsShowModal', modalConfig)
        }
        
      }else if(FEATURENAME.MODIFY== from.name){
        if(store.state.goApply ){
          console.log('gogoApply',store.state.goApply)
              next()
              store.commit('setRouterPath', '') 
              store.commit('setGoApply', false)
        }else{
          const modalConfig = {
          type: POPUP.LEAVEADVANCED,
          data: {
            goNext : next,
            isAdvanced,
          },
          isShow: true,
          }
          store.commit('setIsShowModal', modalConfig)
        }
      }else{
        next()
      }
    })

   

    const applyTheme = (theme) => {
      switch(theme){
        case THEME_OPT.PROART:
          document.body.setAttribute('data-theme', THEME_OPT.PROART);
          document.body.setAttribute('class', THEME_OPT.PROART);
          store.commit('setTheme', THEME_OPT.PROART);
          store.commit('setBrand', BRAND.PROART);
          document.querySelector("link[rel='icon']").setAttribute('href', '/favicon-proart.ico');
          break;
        case THEME_OPT.ASUS:
          document.body.setAttribute('data-theme', THEME_OPT.ASUS);
          document.body.setAttribute('class', THEME_OPT.ASUS);
          store.commit('setTheme', THEME_OPT.ASUS);
          store.commit('setBrand', BRAND.ASUS);
          document.querySelector("link[rel='icon']").setAttribute('href', '/favicon-asus.ico');
          break;
        default:
          document.body.setAttribute('data-theme', THEME_OPT.PROART);
          document.body.setAttribute('class', THEME_OPT.PROART);
          store.commit('setTheme', THEME_OPT.PROART);
          store.commit('setBrand', BRAND.PROART);
          document.querySelector("link[rel='icon']").setAttribute('href', '/favicon-proart.ico');
      }
    }

    const changeTheme = () => {
      const currentURL = window.location.href;
      const currentBrand = getBrand();
      let themeKeyWord = THEME_OPT.PROART;
     
      if (currentURL.includes('adc') || currentBrand == BRAND.PROART || currentURL.includes('localhost')) {
        themeKeyWord = THEME_OPT.PROART;
        document.title = 'ASUS ProArt Color Center';
        //meta name description text change
        document.querySelector('meta[name="description"]').setAttribute('content', 'ProArt Color Center makes color calibration easier! You can centrally calibrate multiple ProArt displays at one time, schedule calibrations, and manage groups.');
      } else if (currentURL.includes('proart-web-stage') || currentBrand == BRAND.ASUS) {
        themeKeyWord = THEME_OPT.ASUS;
        document.title = 'ASUS Color Center';
        document.querySelector('meta[name="description"]').setAttribute('content', 'ASUS Color Center makes color calibration easier! You can centrally calibrate multiple ASUS displays at one time, schedule calibrations, and manage groups.');
      }
      // else if (currentURL.includes('localhost')) {
      //   themeKeyWord = THEME_OPT.ASUS;
      //   document.title = 'ASUS Color Center';
      //   document.querySelector('meta[name="description"]').setAttribute('content', 'ASUS Color Center makes color calibration easier! You can centrally calibrate multiple ASUS displays at one time, schedule calibrations, and manage groups.');
      // }
      console.log('changeTheme', themeKeyWord )
      applyTheme(themeKeyWord);
      document.body.setAttribute('data-theme', themeKeyWord);
    }

    return{
      store,
      queryApiWsSite,
      t,
    }
  },
}</script>

<style>

</style>



